/* ============================================
   CART NOTIFICATION - Drawer & Popup Engine
   Shows cart drawer (desktop) or popup (mobile)
   when a product is added to cart.
   ============================================ */
(function() {
  'use strict';

  var MOBILE_BP = 768;
  var overlay = document.getElementById('cn-overlay');
  var drawer = document.getElementById('cn-drawer');
  var imgEl = document.getElementById('cn-img');
  var titleEl = document.getElementById('cn-title');
  var variantEl = document.getElementById('cn-variant');
  var priceEl = document.getElementById('cn-price');
  var qtyEl = document.getElementById('cn-qty');
  var totalEl = document.getElementById('cn-cart-total');
  var countEl = document.getElementById('cn-item-count');
  var continueBtn = document.getElementById('cn-continue');
  var closeBtn = drawer ? drawer.querySelector('.cn-close') : null;

  if (!drawer || !overlay) return;

  var isOpen = false;
  var moneyFormat = (window.Shopify && window.Shopify.money_format) || 'Rs.{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var formatted = parts.join('.');
    if (formatted.endsWith('.00')) formatted = formatted.slice(0, -3);

    return moneyFormat
      .replace('{{amount_with_comma_separator}}', formatted.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0].replace('.', ','))
      .replace('{{amount_no_decimals}}', parts[0])
      .replace('{{amount}}', formatted);
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('cn-open');
    overlay.classList.add('cn-open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('cn-open');
    overlay.classList.remove('cn-open');
    document.body.style.overflow = '';
  }

  function populateDrawer(addedItem, cart) {
    var img = addedItem.image || addedItem.featured_image || '';
    if (img && img.url) img = img.url;
    if (img) {
      img = img.replace(/(\.\w+)(\?|$)/, '_180x$1$2');
    }
    imgEl.src = img || '';
    imgEl.alt = addedItem.title || addedItem.product_title || '';

    var productTitle = addedItem.product_title || addedItem.title || '';
    titleEl.textContent = productTitle;

    var variantTitle = addedItem.variant_title || '';
    if (variantTitle && variantTitle !== 'Default Title') {
      variantEl.textContent = variantTitle;
    } else {
      variantEl.textContent = '';
    }

    var linePrice = addedItem.final_line_price || addedItem.line_price || addedItem.price || 0;
    priceEl.textContent = formatMoney(linePrice);

    var qty = addedItem.quantity || 1;
    qtyEl.textContent = 'Qty: ' + qty;

    if (cart) {
      totalEl.textContent = formatMoney(cart.total_price);
      var count = cart.item_count || 0;
      countEl.textContent = count + (count === 1 ? ' item' : ' items') + ' in your cart';
    }
  }

  function handleAddToCart(addedData) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var item = null;

        if (addedData && addedData.items && addedData.items.length > 0) {
          item = addedData.items[0];
        } else if (addedData && addedData.id) {
          item = addedData;
        }

        if (!item && cart.items && cart.items.length > 0) {
          item = cart.items[cart.items.length - 1];
        }

        if (!item) return;

        populateDrawer(item, cart);
        open();
      })
      .catch(function() {});
  }

  /* --- Intercept fetch for /cart/add --- */
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function() {
      var url = arguments[0];
      var result = origFetch.apply(this, arguments);

      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        result.then(function(response) {
          var cloned = response.clone();
          cloned.json().then(function(data) {
            setTimeout(function() { handleAddToCart(data); }, 300);
          }).catch(function() {
            setTimeout(function() { handleAddToCart(null); }, 300);
          });
          return response;
        });
      }

      return result;
    };
  }

  /* --- Intercept XMLHttpRequest for /cart/add (some themes use XHR) --- */
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._cnUrl = url;
    return origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    if (xhr._cnUrl && typeof xhr._cnUrl === 'string' && xhr._cnUrl.indexOf('/cart/add') !== -1) {
      xhr.addEventListener('load', function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var data = JSON.parse(xhr.responseText);
            setTimeout(function() { handleAddToCart(data); }, 300);
          } catch(e) {
            setTimeout(function() { handleAddToCart(null); }, 300);
          }
        }
      });
    }
    return origXHRSend.apply(this, arguments);
  };

  /* --- Close handlers --- */
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (continueBtn) continueBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  /* --- Swipe down to close on mobile --- */
  var touchStartY = 0;
  var touchCurrentY = 0;
  var isDragging = false;

  drawer.addEventListener('touchstart', function(e) {
    if (window.innerWidth > MOBILE_BP) return;
    touchStartY = e.touches[0].clientY;
    isDragging = true;
    drawer.style.transition = 'none';
  }, { passive: true });

  drawer.addEventListener('touchmove', function(e) {
    if (!isDragging || window.innerWidth > MOBILE_BP) return;
    touchCurrentY = e.touches[0].clientY;
    var diff = touchCurrentY - touchStartY;
    if (diff > 0) {
      drawer.style.transform = 'translateY(' + diff + 'px)';
    }
  }, { passive: true });

  drawer.addEventListener('touchend', function() {
    if (!isDragging || window.innerWidth > MOBILE_BP) return;
    isDragging = false;
    drawer.style.transition = '';
    var diff = touchCurrentY - touchStartY;
    if (diff > 80) {
      close();
    }
    drawer.style.transform = '';
    touchStartY = 0;
    touchCurrentY = 0;
  });

})();
